import { Injectable } from '@angular/core';
import { BillingApi } from '../api/api/BillingApi';

@Injectable()
export class CurrencyService {
	currencies = undefined;
	isLoading = false;
	resolveBuffer = [];
	constructor(private billingApi: BillingApi) {}
	public getCurrenciesAsObject() {
		const self = this;
		if (!this.isLoading) {
			this.isLoading = true;
			self.billingApi.getBillingCurrencies().subscribe(
				response => {
					console.warn('NEW HTTP REQUEST');
					this.currencies = {};
					response.forEach(currency => {
						this.currencies[currency.code] = currency;
					});
					this.isLoading = false;
					this.resolveBuffer.forEach(resolve => {
						resolve(this.currencies);
					});
				}
			);
		}
		return new Promise((resolve, reject) => {
			if (!this.currencies && this.isLoading) {
				this.resolveBuffer.push(resolve);
			} else if (this.currencies) {
				resolve(this.currencies)
			}
		});
	}
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/currency.service.ts